import { render, staticRenderFns } from "./DefaultImages.vue?vue&type=template&id=1b5c5b57&scoped=true"
import script from "./DefaultImages.vue?vue&type=script&lang=js"
export * from "./DefaultImages.vue?vue&type=script&lang=js"
import style0 from "./DefaultImages.vue?vue&type=style&index=0&id=1b5c5b57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5c5b57",
  null
  
)

export default component.exports